import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Information from './Information';
import { goToPage } from '../../../actions/environment';
import { updateAccountAddress, updateAccountEmail, updateAccountPassword, changeAddressInput, accountOrders } from '../../../actions/checkout';
import { purifier } from '../../../utils/dom';
import { translate } from '../../../utils/locale';
import s from './Authenticated.scss';

const sections = [
	'accountInformation',
	'accountSignOut',
];

const Authenticated = ({ setup, checkout, favourites, ...props }) => {
	const [accordianToggled, toggleAccordian] = useState(sections.reduce((acc, section) => ({ ...acc, [section]: false }), {}));

	const toggleAccordianHandler = (e) => {
		e.preventDefault();
		const value = e.currentTarget.value;

		if (value === 'accountPreviousOrders' && !checkout.account?.orders && (typeof checkout.account.hasMoreOrders === 'undefined' || checkout.account.hasMoreOrders)) {
			// Get latest orders
			props.accountOrders();
		}

		toggleAccordian((prevState) => ({
			...prevState,
			[value]: !prevState[value],
		}));
	};

	return (
		<div className={s.authenticated}>
			<section className={s.authenticated_section}>
				<div className={s.authenticated_section_content}>
					<div className={s.authenticated_section_content_inner} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, 'accountIntro'), {}, setup) }} />
				</div>
			</section>
			{
				sections.map((section, i) => (
					<section className={[s.authenticated_section, (accordianToggled[section] ? s.authenticated_section__expanded : null)].join(' ')}>
						<button aria-controls={section} aria-expanded={accordianToggled[section]} type="button" onClick={toggleAccordianHandler} className={s.authenticated_section_title} value={section}>
							<span>{ `${i + 1}. ${translate(setup, `${section}Title`)}` }</span>
						</button>
						<div aria-hidden={!accordianToggled[section]} id={section} className={[s.authenticated_section_content, s[`authenticated_section_content__${section}`]].join(' ')}>
							{
								section === 'accountInformation' && (
									<div className={s.authenticated_section_content_inner}>
										<Information setup={setup} checkout={checkout} {...props} />
									</div>
								)
							}
							{ section === 'accountSignOut' && <div className={s.authenticated_section_content_inner} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, 'accountSignOutContent'), {}, setup) }} /> }
						</div>
					</section>
				))
			}
		</div>
	);
};

const mapState = ({ environment, checkout }, props) => ({ checkout, favourites: environment.favourites, ...props });

export default hot(module)(connect(mapState, { updateAccountAddress, updateAccountEmail, updateAccountPassword, changeAddressInput, goToPage, accountOrders })(Authenticated));
